import React from 'react'
import { View, StyleSheet, ScrollView, Image } from 'react-native'
import { connect } from 'react-redux'
import localize from '../../../localize'
import { PrimaryTitle, PrimarySubtitle } from '../../../components/labels';
import { getSkillData, getTopSkill } from '../../../action';
import { action } from '../../../const';
import Header from '../../../components/Header';
import { AmericaU_cert } from '../../../assets';

class Skillcertificate extends React.Component {

  constructor(props) {
    super(props)
    const query = new URLSearchParams(props.location.search);
    const id = query.get('userId');
    this.state = {
      id,
      skillData: null,
      topSkill: null,
      topSkillHours: 0
    }
  }

  componentDidMount() {
    this.initData()
  }

  initData = async () => {
    this.props.isLoading(true)
    let res = await this.props.getSkillData(this.state.id);
    let resTopSkill = await this.props.getTopSkill(this.state.id);
    this.props.isLoading(false)
    if (res.code === 200) {
      let topSkillHours = 0
      resTopSkill.data.map(item => {
        topSkillHours += item.hours
      })
      this.setState({ skillData: res, topSkill: resTopSkill.data, topSkillHours })
    }
  }

  render() {
    const { skillData, topSkill, topSkillHours } = this.state
    const SkillRow = ({ index, title, value }) => (
      <View style={{ flexDirection: 'row', padding: 10, backgroundColor: index % 2 !== 0 ? '#DAF0F7' : '#fff' }}>
        <View style={{ width: 30 }}>
          <PrimaryTitle size={16}>{index}.</PrimaryTitle>
        </View>
        <View style={{ flex: 1, marginRight: 5 }}>
          <PrimaryTitle size={16}>{title}</PrimaryTitle>
        </View>
        <PrimaryTitle align='center' size={14}>{value}</PrimaryTitle>
      </View>
    )

    const TopSkillRow = ({ index, title, level, value }) => {
      let indexArr = ['a', 'b', 'c', 'd', 'e', 'f']
      return (
        <View style={{ flexDirection: 'row', padding: 10 }}>
          <View style={{ width: 30 }}>
            <PrimaryTitle size={16}>{indexArr[index]}.</PrimaryTitle>
          </View>
          <View style={{ flex: 1, marginRight: 5 }}>
            <PrimaryTitle size={16}>{title}</PrimaryTitle>
            <PrimaryTitle size={14}>{level}</PrimaryTitle>
          </View>
          <PrimaryTitle align='center' size={14}>{value}</PrimaryTitle>
        </View>
      )
    }
    if (!skillData) return null
    return (
      <View style={styles.root}>
        <Header title={localize.My_Life_Skills_Learning_Portfolio} goBack={() => this.props.history.goBack()} />
        <ScrollView >
          <View style={{ flexDirection: 'row' }}>
            <View style={{ padding: 10, marginBottom: 20, flex: 1 }}>
              <PrimaryTitle>{localize.Enrolled} {skillData?.register_date}</PrimaryTitle>
              <PrimarySubtitle>{localize.Attended} {skillData?.active_days} {localize.days_of} {skillData?.exist_days}</PrimarySubtitle>
            </View>
            <Image source={AmericaU_cert} style={{ width: 100, height: 100, resizeMode: 'contain', marginRight: 10 }} />
          </View>
          <SkillRow
            index={1}
            title={localize.Game_based_Life_skills_Simulation_Hours}
            value={`${skillData?.online_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={2}
            title={localize.Virtual_Wealth_Created_thru_Entrepreneurial_Work}
            value={`$${skillData?.my_worth}`}
          />
          <SkillRow
            index={3}
            title={localize.Health_Skills_hours}
            value={`${skillData?.health_cost_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={4}
            title={localize.Character_Skills_hours}
            value={`${skillData?.character_cost_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={5}
            title={localize.Global_Ranking}
            value={skillData?.wcr_world_rank}
          />
          <SkillRow
            index={6}
            title={localize.Certificate_of_Entrepreneurship}
            value={`${skillData?.entrepreneur_cost_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={7}
            title={localize.Family_Connection}
            value={`${skillData?.team_cost_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={8}
            title={localize.Good_Habit_Training}
            value={`${skillData?.building_cost_time}${'\n'}${localize.hours}`}
          />
          <SkillRow
            index={9}
            title={localize.Critical_Thinking_Problem_Solving}
            value={`${skillData?.solve_cost_time}${'\n'}${localize.hours}`}
          />
          {
            topSkill && topSkill?.length > 0 && (
              <View>
                <SkillRow
                  index={10}
                  title={localize.Top_5_21st_Century_Skills}
                  value={`${topSkillHours}${'\n'}${localize.hours}`}
                />
                <View style={{ marginLeft: 15 }}>
                  {
                    topSkill && topSkill?.map((item, i) => (
                      <TopSkillRow
                        index={i}
                        key={String(i)}
                        title={item.standard}
                        level={item.grade}
                        value={`${item.hours}${'\n'}${localize.hours}`}
                      />
                    ))
                  }
                </View>
              </View>
            )
          }
        </ScrollView>
      </View>
    )
  }
}

const mapDispatch = (dispatch) => {
  return {
    getSkillData: (id) => dispatch(getSkillData(id)),
    getTopSkill: (id) => dispatch(getTopSkill(id)),
    isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
  }
}

export default connect(null, mapDispatch)(Skillcertificate)

const styles = StyleSheet.create({
  root: {
    flex: 1
  }
})
